'use client';
import { useState } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import Button from 'antd/es/button';
import Popover from 'antd/es/popover';
import { AvailableLangs, LANGUAGES_ICON_MAPPER } from '../lib/constants';
import { useChangeLang } from '../model/useChangeLang';
import styles from './styles.module.scss';

const ChangeLang = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { lang, onChange } = useChangeLang();

  const handleClick = (language: AvailableLangs) => () => {
    dayjs.locale(language);
    onChange(language);
    setIsOpen(false);
  };

  return (
    <Popover
      open={isOpen}
      content={
        <div className={styles.lang}>
          {Object.entries(LANGUAGES_ICON_MAPPER).map(([key, value]) => (
            <Button key={key} className={styles.langBtn} type='text' onClick={handleClick(key as AvailableLangs)}>
              {value}

              {t(`lang.${key}`)}
            </Button>
          ))}
        </div>
      }
      trigger='click'
      onOpenChange={setIsOpen}
    >
      <div className={styles.icon}>{LANGUAGES_ICON_MAPPER[lang]}</div>
    </Popover>
  );
};

export default ChangeLang;
